import { Button } from '@/components/ui/button';
import type { MappedPaymentAnalysisGraphData } from '@/models/graphs';
import type { ColumnDef } from '@tanstack/vue-table';
import { ArrowUpDown } from 'lucide-vue-next';
import { h } from 'vue';

export const paymentAnalysisColumns: ColumnDef<MappedPaymentAnalysisGraphData>[] = [
  {
    accessorKey: 'name',
    header: ({ column }) => {
      return h(
        Button,
        {
          class: '!p-0',
          variant: 'ghost',
          onClick: () => column.toggleSorting(column.getIsSorted() === 'asc'),
        },
        () => ['Month', h(ArrowUpDown, { class: 'ml-2 h-4 w-4' })],
      );
    },
    cell: ({ getValue }) => getValue(),
  },
  {
    accessorKey: 'Total Payments',
    header: () => h('div', { class: 'text-right' }, 'Total Payments'),
    cell: ({ getValue }) => {
      return h('div', { class: 'text-right' }, getValue() as number);
    },
  },
];
